const SCRIPT_NAME = 'textareaAutoHeight.js';

/**
 * Funktion zur automatischen Anpassung der Höhe von <textarea>-Felder basierend auf deren Inhalt
 */
export function initTextareaAutoHeight() {
    utils.consoleLog(SCRIPT_NAME, 'Initialisierung gestartet');

    // Alle <textarea> mit dem Attribut data-auto-height-textarea finden
    const TEXT_AREAS = document.querySelectorAll('[data-auto-height-textarea]');

    if (TEXT_AREAS.length === 0) {
        utils.consoleLog(SCRIPT_NAME, 'Keine Textareas mit [data-auto-height-textarea] gefunden');
        return; // Keine Textareas vorhanden, keine Aktion notwendig
    }

    utils.consoleLog(SCRIPT_NAME, `Textareas gefunden: ${TEXT_AREAS.length}`);

    // Höhe beim Laden der Seite anpassen
    TEXT_AREAS.forEach(adjustTextareaHeight);

    // Event-Listener für Texteingabe hinzufügen
    TEXT_AREAS.forEach(textarea => {
        textarea.addEventListener('input', function () {
            adjustTextareaHeight(this);
        });
        utils.consoleLog(SCRIPT_NAME, 'Event-Listener für input hinzugefügt', textarea);
    });

    /**
     * Passt die Höhe eines <textarea> an, basierend auf dem scrollHeight des Inhalts.
     * @param {HTMLElement} textarea
     */
    function adjustTextareaHeight(textarea) {
        textarea.style.height = 'auto'; // Setzt die Höhe zurück
        textarea.style.height = `${textarea.scrollHeight}px`; // Passt die Höhe an den Inhalt an
        utils.consoleLog(SCRIPT_NAME, `Textarea-Höhe angepasst: ${textarea.scrollHeight}px`, textarea);
    }

    utils.consoleLog(SCRIPT_NAME, 'Initialisierung abgeschlossen');
}